import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PersistenceModule } from 'angular-persistence';
import { ReactiveFormsModule } from '@angular/forms';
import { DataTableModule } from 'angular-4-data-table-bootstrap-4';
import { NgxMaskModule } from 'ngx-mask';
import { UserIdleModule } from 'angular-user-idle';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { TimoutDialogComponent } from './components/dialogs/timout-dialog/timout-dialog.component';

import { LoginModule } from './components/login/login.module';
import { HomeModule } from './components/home/home.module';
import { UscStoreModule } from './components/usc-store/usc-store.module';
import { OomphModule } from './components/oomph/oomph.module';
import { BeasleyModule } from './components/beasley/beasley.module';
import { PersistenceService } from 'angular-persistence';

import {
    SessionService,
    ApiService,
    AuthService,
    AdminService,
    HeaderService,
    FooterService,
    ModelService,
    MetadataService,
    FieldService,
    ConditionService,
    MessagingService,
    ModalService,
    DialogService,
    FormulaService,
    TranslatorService,
    ProjectService,
    BoldBiService
} from './services';

import { SharedModule } from './shared.module';
import { CalendarModule } from 'angular-calendar';
import { UscCampaignModule } from './components/usc-campaign/usc-campaign.module';
import { UscBiModule } from './components/usc-bi/usc-bi.module';
import { SidebarModule } from '@syncfusion/ej2-angular-navigations';
import { CalendarService } from './services/calendar.service';
import { UscStoreMobileModule } from './components/usc-store-mobile/usc-store-mobile.module';
import { FiledropDirective } from './directives/filedrop.directive';
import { UscStoreSchedulingModule } from './components/usc-store-scheduling/usc-store-scheduling.module';

const rootRouting: ModuleWithProviders = RouterModule.forRoot([], { useHash: true });

@NgModule({
    declarations: [
        AppComponent,
        FiledropDirective,
    ],
    imports: [
        PersistenceModule,
        BrowserModule,
        BrowserAnimationsModule,
        rootRouting,
        LoginModule,
        SharedModule,
        DataTableModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(),
        NgbModule.forRoot(),
        CalendarModule.forRoot(),
        SidebarModule,
        //client modules
        HomeModule,
        UscStoreModule,
        OomphModule,
        BeasleyModule,
        UscCampaignModule,
        UscBiModule,
        UscStoreMobileModule,
        UscStoreSchedulingModule,
        UserIdleModule.forRoot({ idle: 5, timeout: (environment.production != true) ? 30 * 60 : 60 * 60, ping: 1 * 60 })
    ],
    providers: [
        PersistenceService,
        ApiService,
        AuthService,
        AdminService,
        SessionService,
        ModelService,
        MetadataService,
        FieldService,
        ConditionService,
        MessagingService,
        ModalService,
        DialogService,
        FormulaService,
        TranslatorService,
        BoldBiService,
        CalendarService,
        ProjectService,
    ],
    entryComponents: [
        TimoutDialogComponent,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/app.module.ts